import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { DeviceDetectorModule } from 'ngx-device-detector';
import {
  ApiService,
  ConfigurationService,
  NotifyService,
  UtilityService,
  TranslateService,
  CacheService,
  ExcelService,
  LoadingService,
  SettingService
} from '../services';
import {
  SdCurrencyPipe,
  SdTimeDifferentPipe,
  SdSafeHtmlPipe,
  SdTranslatePipe
} from '../pipes';
import '../typings';
import { DialogConfirmComponent } from '../components';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    DeviceDetectorModule.forRoot()
  ],
  declarations: [
    SdTranslatePipe,
    SdCurrencyPipe,
    SdTimeDifferentPipe,
    SdSafeHtmlPipe,
    DialogConfirmComponent
  ],
  exports: [
    SdCurrencyPipe,
    SdTimeDifferentPipe,
    SdSafeHtmlPipe,
    SdTranslatePipe
  ]
})
export class SdServiceModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SdServiceModule,
      providers: [
        ApiService,
        ConfigurationService,
        NotifyService,
        UtilityService,
        TranslateService,
        CacheService,
        ExcelService,
        LoadingService,
        SettingService,
        SdCurrencyPipe
      ]
    };
  }
  static forChild(): ModuleWithProviders {
    return {
      ngModule: SdServiceModule,
      providers: []
    };
  }
}
